import { get } from 'lodash';

export default (data, field) => {
  return data && (
    get(data, ['quota', field], false) ||
    get(data, ['total', field], false)
  );
};
